import { cn } from '@helpers/styleUtils';
import { cva } from 'class-variance-authority';
import PropTypes from 'prop-types';

const badgeVariants = cva(
    'inline-flex items-center rounded-md border px-2.5 py-0.5 text-xs font-semibold transition-colors focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2',
    {
        variants: {
            variant: {
                default:
                    'border-transparent bg-primary-blue text-white shadow hover:bg-primary-blue/80',
                warning: 'border-transparent bg-[#E98418] text-white shadow hover:bg-[#E98418]/80',
                success: 'border-transparent bg-[#31C121] text-white shadow hover:bg-[#31C121]/80',
                completed:
                    'border-transparent bg-green-800 text-white shadow hover:bg-green-800/80',
                danger: 'border-transparent bg-[#EB5757] text-white shadow hover:bg-[#EB5757]/80',
                outline: 'text-foreground',
            },
        },
        defaultVariants: {
            variant: 'default',
        },
    },
);

function Badge({ className, variant, ...props }) {
    return <div className={cn(badgeVariants({ variant }), className)} {...props} />;
}

Badge.propTypes = {
    className: PropTypes.string,
    variant: PropTypes.string,
};

export { Badge, badgeVariants };
